import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Card from '@classify/react-core-components/Card';
import type { CardProps } from '@classify/react-core-components/Card';
import { useRef } from 'react';
export interface Props {
  children: React.ReactNode;
  isImprovedMode?: boolean;
  isLoading?: boolean;
}
const Wrapper = styled(Card)<CardProps>(({
  theme: {
    palette,
    radius
  }
}) => {
  const color1 = 'rgb(157, 169, 243)';
  const color2 = 'rgb(255, 123, 109)';
  return {
    '@keyframes gradientScrolling': {
      '0%': {
        backgroundPosition: '0% 100%'
      },
      '50%': {
        backgroundPosition: '50% 100%'
      },
      '100%': {
        backgroundPosition: '0% 100%'
      }
    },
    cursor: 'text',
    width: '100%',
    position: 'relative',
    borderRadius: radius.field,
    overflow: 'hidden',
    border: 'none',
    padding: 1,
    backgroundColor: palette.form.field.border.enabled,
    '&:hover': {
      backgroundColor: palette.form.field.border.focus
    },
    '& > div': {
      backgroundColor: palette.form.field.background.enabled,
      borderRadius: radius.field,
      overflow: 'hidden'
    },
    '& .MuiFormControl-root': {
      width: '100%'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '&:has(textarea:focus), &:has(input:focus), &.is-loading': {
      padding: 2,
      backgroundColor: palette.form.field.border.focus,
      '& > div > .MuiBox-root': {
        margin: '0 -2px -1px -1px'
      },
      '& .MuiInputBase-root': {
        margin: '-1px -1px 0 -1px'
      }
    },
    '&.is-improved, &.is-loading': {
      backgroundImage: `linear-gradient(270.0deg, ${color1}, ${color2}, ${color1}, ${color2}, ${color1})`,
      backgroundSize: '200% 100%'
    },
    '&.is-loading': {
      animation: 'gradientScrolling 2s linear infinite'
    }
  };
});
const SmartInputWrapper = t0 => {
  const $ = _c(9);
  const {
    children,
    isLoading,
    isImprovedMode: t1
  } = t0;
  const isImprovedMode = t1 === undefined ? false : t1;
  const wrapperRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      const target = event.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "BUTTON") {
        return;
      }
      if (wrapperRef.current) {
        const firstInput = wrapperRef.current.querySelector("input, textarea") as HTMLElement;
        if (firstInput) {
          firstInput.focus();
        }
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleWrapperClick = t2;
  let classNames;
  if ($[1] !== isImprovedMode || $[2] !== isLoading) {
    classNames = [];
    if (isLoading) {
      classNames.push("is-loading");
    }
    if (isImprovedMode) {
      classNames.push("is-improved");
    }
    $[1] = isImprovedMode;
    $[2] = isLoading;
    $[3] = classNames;
  } else {
    classNames = $[3];
  }
  const t3 = classNames.join(" ");
  let t4;
  if ($[4] !== children) {
    t4 = <div>{children}</div>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Wrapper ref={wrapperRef} className={t3} onClick={handleWrapperClick}>{t4}</Wrapper>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
SmartInputWrapper.displayName = 'SmartInputWrapper';
export default SmartInputWrapper;